<template>
  <div id="Transaction">
   <div class="card">
     <div class="card-header">
       <h3 class="card-title">ترکنش ها</h3>
       <CButton @click="filtershow=true" v-if="!filtershow" style="float: left;margin-left: 10px;margin-top: 10px">
         <CIcon  name="cil-filter" style="width: 30px;height: 30px;float: left;color: blue;"/>
       </CButton>
       <CButton @click="[filtershow=false,TransactionFilter(0)]" v-else style="float: left;margin-left: 10px;margin-top: 10px">
         <CIcon  name="cil-filter-x" style="width: 30px;height: 30px;float: left;color: blue;"/>
       </CButton>
     </div>
     <div>

     </div>
     <CCollapse style="float: right;width: 100%;" :show="filtershow"  :duration="1000">
       <CCardBody style="float: right;width: 100%;height:200px;">
        <div>
          <CRow class="align-items-start" style="direction: rtl">
            <CCol>
              <CInput
                  label="شناسه:"
                  valid-feedback=""
                  invalid-feedback="حداقل شش  کارکتر لاتین"
                  value=""
                  v-model="Filter.ID"
                  :is-valid="true"
              />
            </CCol>
            <CCol>
              <CInput
                  label="شماره مرجع:"
                  valid-feedback=""
                  invalid-feedback="حداقل شش  کارکتر لاتین"
                  value=""
                  v-model="Filter.Ref"
                  :is-valid="true"
              />
            </CCol>
            <CCol>
              <CInput
                  label="مبلغ:"
                  valid-feedback=""
                  invalid-feedback="حداقل شش  کارکتر لاتین"
                  value=""
                  v-model="Filter.Amount"
                  :is-valid="true"
              />
            </CCol>
            <CCol>
              <CInput
                  label="موجودی:"
                  valid-feedback=""
                  invalid-feedback="حداقل شش  کارکتر لاتین"
                  value=""
                  v-model="Filter.Balance"
                  :is-valid="true"
              />
            </CCol>

          </CRow>
          <CRow class="align-items-start" style="direction: rtl">
            <CCol>
              <CInput
                  label="کارت:"
                  valid-feedback=""
                  invalid-feedback="حداقل شش  کارکتر لاتین"
                  value=""
                  v-model="Filter.CartID"
                  :is-valid="true"
              />
            </CCol>
            <CCol>
              <CInput
                  label="شماره حساب:"
                  valid-feedback=""
                  invalid-feedback="حداقل شش  کارکتر لاتین"
                  value=""
                  v-model="Filter.AccountID"
                  :is-valid="true"
              />
            </CCol>
            <CCol>
              <CInput
                  label="پایانه:"
                  valid-feedback=""
                  invalid-feedback="حداقل شش  کارکتر لاتین"
                  value=""
                  v-model="Filter.TerminalID"
                  :is-valid="true"
              />
            </CCol>
            <CCol>
              <CInput
                  label="پذیرنده:"
                  valid-feedback=""
                  invalid-feedback="حداقل شش  کارکتر لاتین"
                  value=""
                  v-model="Filter.MerchantID"
                  :is-valid="true"
              />
            </CCol>

          </CRow>
          <CRow class="align-items-start" style="direction: rtl">

            <CCol>
              <!-- <div style="display:flex;gap:5px">
                  <label for="stTime">از:</label>
                  <date-picker  id="stTime" v-model="Filter.fromDate" aria-label="از تاریخ" type="datetime"></date-picker>
              </div> -->
              

            </CCol>
            <CCol>
              <!-- <div style="display:flex;gap:5px">
                  <label for="stopTime">تا:</label>
                  <date-picker  id="stopTime" v-model="Filter.toDate" aria-label="از تاریخ" type="datetime"></date-picker>
              </div> -->
            </CCol>
            <CCol>
              <CButton style="float: left;direction:rtl;margin-left: 5px" color="primary" @click="TransactionFilter(0)"><span style="float: left;font-size: 13px"> جستجو </span> &nbsp;&nbsp; <CIcon  name="cil-search" style="width: 13px;height: 13px;color: white;"/>&nbsp;&nbsp;&nbsp;</CButton>&nbsp;&nbsp;&nbsp;
              <!-- <CButton style="float: left;direction:rtl;margin-left: 5px" color="primary" @click="[Filter.ID='',Filter.Ref='',Filter.Amount='',Filter.Balance='',Filter.CartID='',Filter.AccountID='',Filter.TerminalID='',Filter.MerchantID='',GetTransactionFilter(0,10)]"> <span style="float: left;font-size: 13px">بازنشانی</span> <CIcon  name="cil-action-undo" style="width: 13px;height: 13px;color: white;"/>&nbsp;&nbsp;&nbsp;</CButton>&nbsp;&nbsp;&nbsp; -->
              <CButton style="float: left;direction:rtl;margin-left: 5px" color="primary" @click="[filter=false,GetTransaction(0,10)]"><span style="float: left;font-size: 13px">بستن</span> <CIcon  name="cil-filter-x" style="width: 13px;height: 13px;color: white;"/>&nbsp;&nbsp;&nbsp;</CButton>&nbsp;&nbsp;&nbsp;

            </CCol>

          </CRow>
        </div>

       </CCardBody>
     </CCollapse>
     <div class="card-body">
       <CDataTable
           :hover="true"
           :border="true"
           
           :striped="true"
           :loading="loading"
           :small="true"
           :items="Transaction.content"
           :fields="fieldObject"
           :fixed="true"
           :items-per-page="10"
           pagination
           style="float: right;width: 100%;overflow: hidden;margin-top: 20px;direction: rtl;"
           :noItemsView="{ noResults: 'چیزی یافت نشد.', noItems: 'چیزی برای نمایش وجود ندارد.' }"

       >
        <template #localDateTime="{item}">
          <td>
            {{GetTime(item.localDateTime)}}
          </td>
        </template>
        <template #receiveDate="{item}">
          <td>
            {{GetTime(item.receiveDate)}}
          </td>
        </template>
       </CDataTable>
       <CPagination
           size="lg"
           style="float: right;width: 100%;overflow: hidden;margin-top: 20px;direction: rtl;"
           @update:activePage="Change"
           v-if="Transaction.totalPages>1"
           :active-page.sync="Transaction.number"
           :pages="Transaction.totalPages"/>

     </div>
   </div>
  </div>
</template>

<script>
import Constant from "../../assets/Constants";
import Vue from 'vue'
export default {
  name: "Transaction",
  data(){
    return {
        filtershow:false,
        Transaction:{},
        Filter:{
          ID:"",
          Ref:"",
          Amount:"",
          Balance:"",
          CartID:"",
          AccountID:"",
          TerminalID:"",
          MerchantID:"",
          fromDate:'1400/05/02 00:00',
          toDate:'1400/05/02  23:59',
        },
        
        loading:false,
        fieldObject:[{key:'transactionId',label:'شناسه'},{key:'id',label:'شماره مرجع'},{key:'amount',label:'مبلغ'},{key:'balance',label:'موجودی'},{key:'pan',label:'کارت'},{key:'receiveDate',label:'تاریخ دریافت'}
        ,{key:'localDateTime',label:'تاریخ تراکنش'}
        ,{key:'terminalCode',label:'پایانه'}
        ,{key:'merchantCode',label:'پذیرنده'}],
      currentPage:1,
    }
  },
  computed:{
    ReadTransactionFilter(){
      return this.$store.state.TransactionFilter;
    }
  },
  watch:{
    ReadTransactionFilter(res){
      if(res.Status){
        this.Transaction=res.data;
      }
    }
  },
  mounted() {
    this.TransactionFilter(0);
    var timeNow=Vue.moment().format('YYYY-MM-DD HH:mm:ss');
    var timefrom=Vue.moment().subtract(7,'days').format('YYYY-MM-DD HH:mm:ss');
    this.Filter.toDate=Vue.moment(timeNow, "YYYY-MM-DD HH:mm:ss").format("jYYYY-jMM-jDD HH:mm:ss");
    this.Filter.fromDate=Vue.moment(timefrom, "YYYY-MM-DD HH:mm:ss").format("jYYYY-jMM-jDD HH:mm:ss");
  },
  methods:{
    TransactionFilter(page){
      var body={
        page:page,
        size:10,
        //fleetId: "002120",
      }
      if(this.filtershow){
        if(this.Filter.TerminalID!==null && this.Filter.TerminalID!==''){
          body.terminalCode=this.Filter.TerminalID;
        }
        if(this.Filter.MerchantID!==null && this.Filter.MerchantID!==''){
          body.merchantCode=this.Filter.MerchantID;
        }
        if(this.Filter.CartID!==null && this.Filter.CartID!==''){
          body.pan=this.Filter.CartID;
        }
        if(this.Filter.Amount!==null && this.Filter.Amount!==''){
          body.amount=this.Filter.Amount;
        }
        if(this.Filter.Amount!==null && this.Filter.Amount!==''){
          body.amount=this.Filter.Amount;
        }
        if(this.Filter.Balance!==null && this.Filter.Balance!==''){
          body.balance=this.Filter.Balance;
        }
        if(this.Filter.ID!==null && this.Filter.ID!==''){
          body.transactionId=parseInt(this.Filter.ID);
        }
        var from=Vue.moment(this.Filter.fromDate, "jYYYY-jMM-jDD HH:mm").format("YYYY-MM-DDTHH:mm:ss");
        var to=Vue.moment(this.Filter.toDate, "jYYYY-jMM-jDD HH:mm").format("YYYY-MM-DDTHH:mm:ss");
        // body.startTime= from+".000Z";
        // body.endTime= to+".000Z";
      }
      this.$store.commit('TransactionFilter',body);
    },
    GetTransaction(page,size){
      this.loading=true;
      this.currentPage=page;
      var url=Constant.TransactionFilter;
      url=url.replace("$page",page);
      url=url.replace("$size",size);
      var that=this;
      this.axios
          .get(url)
          .then(response => {
            that.Loading = false
            var data=response.data;
            console.log(data)
            this.Transaction=data;

          }).catch(function (error) {
        console.log(error);
      })
          .finally(() =>{
            that.loading=false;

          } );
    },
    GetTransactionFilter(page,size){
      this.loading=true;
      this.currentPage=page;
      var url=Constant.TransactionSearch;
      url=url.replace("$page",page);
      url=url.replace("$size",size);
      if(this.Filter.ID.length!==0){
        url+="trn_id%3D%3D"+this.Filter.ID+"%3B";
      }
      if(this.Filter.Ref.length!==0){
        url+="trn_ref_number%3Dlk%3D"+this.Filter.Ref+"%3B";
      }
      if(this.Filter.Amount.length!==0){
        url+="trn_amount%3D%3D"+this.Filter.Amount+"%3B";
      }
      if(this.Filter.Balance.length!==0){
        url+="trn_balance%3D%3D"+this.Filter.Balance+"%3B";
      }
      if(this.Filter.CartID.length!==0){
        url+="trn_card_id%3Dlk%3D"+this.Filter.CartID+"%3B";
      }
      if(this.Filter.AccountID.length!==0){
        url+="trn_account_id%3Dlk%3D"+this.Filter.AccountID+"%3B";
      }
      if(this.Filter.TerminalID.length!==0){
        url+="trn_terminal_id%3D%3D"+this.Filter.TerminalID+"%3B";
      }
      if(this.Filter.MerchantID.length!==0){
        url+="trn_merchant_id%3D%3D"+this.Filter.MerchantID;
      }
      if(url.substr(url.length-3,url.length)==="%3B"){
        url=url.substr(0,url.length-3);
      }
      var that=this;
      this.axios
          .get(url)
          .then(response => {
            that.Loading = false
            var data=response.data;
            console.log(data)
            this.Transaction=data;

          }).catch(function (error) {
        console.log(error);
      })
          .finally(() =>{

            that.loading=false;
          } );
    },
    Change(val,val2){
      console.log("OK --> ",val,val2);
      this.TransactionFilter(val)

    },
    GetTime(time){
      if(time!=null){
          var dateTime=Vue.moment(time, "YYYY-MM-DDTHH:mm:ss").format("jYYYY-jMM-jDD HH:mm:ss");    
      return dateTime;
      }
      else {
        return "نا مشخص";
      }
    },
  }
}
</script>

<style scoped>

</style>